import React, { useState, useEffect } from 'react';

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeItem, setActiveItem] = useState('');


  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  useEffect(() => {
    const servicesItem = document.querySelector('.menu-item-has-children');
    if (servicesItem) {
      servicesItem.addEventListener('mouseenter', () => {
        const dropdown = servicesItem.querySelector('ul');
        if (dropdown) dropdown.style.display = 'flex';
      });

      servicesItem.addEventListener('mouseleave', () => {
        const dropdown = servicesItem.querySelector('ul');
        if (dropdown) dropdown.style.display = 'none';
      });
    }
  }, []);


  useEffect(() => {
    const submenus = document.querySelectorAll('.slicknav_parent ul');
    submenus.forEach(submenu => {
      submenu.style.display = 'none';
    });
  }, []);

  useEffect(() => {
    const path = window.location.pathname;
    setActiveItem(path);
  }, []);

  const isActive = (path) => {
    return activeItem === path ||
      (path === '/' && activeItem === '') ||
      (activeItem.startsWith(path) && path !== '/');
  };

  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (dropdownId, event) => {
    if (event) event.preventDefault();
    setOpenDropdown(openDropdown === dropdownId ? null : dropdownId);
  };

  const handleNavClick = (path) => {
    setActiveItem(path);
    setOpenDropdown(null);
  };


  const hasActiveChild = (paths) => {
    return paths.some(path => isActive(path));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const mobileMenu = document.querySelector('.slicknav_nav');
      const menuButton = document.querySelector('.slicknav_btn');

      if (isMobileMenuOpen &&
        mobileMenu &&
        !mobileMenu.contains(event.target) &&
        menuButton &&
        !menuButton.contains(event.target)) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  // Toggle submenus in mobile view
  const toggleSubmenu = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent event bubbling

    const parent = e.target.closest('.slicknav_parent');
    if (!parent) return;

    const submenu = parent.querySelector('ul');
    if (!submenu) return;

    const isHidden = submenu.style.display === 'none' || !submenu.style.display;

    submenu.style.display = isHidden ? 'block' : 'none';

    if (isHidden) {
      parent.classList.remove('slicknav_collapsed');
      parent.classList.add('slicknav_open');
    } else {
      parent.classList.remove('slicknav_open');
      parent.classList.add('slicknav_collapsed');
    }
  };

  return (
    <div>
      <header id="masthead" className="site-header site-header-transparent">
        {/* Top Header */}
        <div className="top-header">
          <div className="container mt-2">
            <div className="row">
              <div className="col-lg-8 d-none d-lg-block">
                <div className="header-contact-info">
                  <ul>
                    {/* WhatsApp */}
                    <li>
                      <a
                        href="https://wa.me/919629456090"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                          setTimeout(() => {
                            window.location.reload();
                          }, 300);
                        }}
                      >
                        <i className="fa-brands fa-square-whatsapp " /> +91 9629456090
                        {/* <i class="fa-brands fa-square-whatsapp fa-2xs" style="color: #B197FC;"></i> */}
                      </a>
                    </li>

                    {/* Gmail */}
                    <li>
                      <a
                        href="https://mail.google.com/mail/?view=cm&fs=1&to=info@codenixinfotech.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                          setTimeout(() => {
                            window.location.reload();
                          }, 300);
                        }}
                      >
                        <i className="fas fa-envelope" /> info@codenixinfotech.com
                      </a>
                    </li>


                    <li>
                      <a
                        href="https://www.google.com/maps/search/?api=1&query=The+Executive+Zone+Anna+Salai+Chennai"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fas fa-map-marker-alt" /> Chennai
                      </a>
                    </li>


                  </ul>
                </div>
              </div>


              <div className="col-lg-4 d-flex justify-content-lg-end justify-content-end">
                <div className="header-social social-links mx-2">
                  <ul>
                    <li><a href="https://www.facebook.com/profile.php?id=61585240401460" onClick={() => { setTimeout(() => { window.location.reload(); }, 300); }} target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f" /></a></li>
                    <li><a href="https://x.com/Codenixinfotech/" onClick={() => { setTimeout(() => { window.location.reload(); }, 300); }} target="_blank" rel="noopener noreferrer"><i class="fab fa-x-twitter" /></a></li>
                    {/* <li><a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube" /></a></li> */}
                    <li><a href="https://www.instagram.com/codenix_infotech/" onClick={() => { setTimeout(() => { window.location.reload(); }, 300); }} target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram" /></a></li>
                    <li><a href="https://www.linkedin.com/company/codenix-infotech-private-limited/" onClick={() => { setTimeout(() => { window.location.reload(); }, 300); }} target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin" /></a></li>
                  </ul>
                  <div className="d-sm-block d-lg-none d-md-none">
                    <li>
                      <a
                        href="https://wa.me/919629456090"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                          setTimeout(() => {
                            window.location.reload();
                          }, 300);
                        }}
                      >
                        <i className="fa-brands fa-square-whatsapp" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://mail.google.com/mail/?view=cm&fs=1&to=info@codenixinfotech.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                          setTimeout(() => {
                            window.location.reload();
                          }, 300); // reload after Gmail opens
                        }}
                      >
                        <i className="fas fa-envelope" />
                      </a>
                    </li>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        {/* Bottom Header */}
        <div className="bottom-header">
          <div className="container">
            <div className="hgroup-wrap d-flex justify-content-between align-items-center">
              <div className="site-identity">
                <h1 className="site-title">
                  <a href="/">
                    {/* <img src="assets/images/site-logo.png" alt="logo" /> */}
                    <img src="assets/images/Codenix.png" alt="logo11" height={100} width={150} />
                  </a>
                </h1>
              </div>


              <div className="d-flex justify-content-end align-items-end ">
                <div className="main-navigation ">
                  <nav id="navigation" className="navigation d-none d-lg-inline-block">
                    <ul>
                      <li className={isActive('/') ? 'current-menu-item' : ''}>
                        <a href="/" onClick={() => setActiveItem('/')}>Home</a>
                      </li>
                      <li className={isActive('/about') ? 'current-menu-item' : ''}>
                        <a href="/about" onClick={() => setActiveItem('/about')}>About Us</a>
                      </li>

                      <li className={`menu-item-has-children d-none ${hasActiveChild(['/Services', '/service-detail', '/search-page', '/single-page']) ? 'current-menu-item' : ''}`} >
                        <a href="#" onClick={(e) => toggleDropdown('services', e)}>Services</a>
                        <ul style={{
                          width: '250px',
                          display: openDropdown === 'services' ? 'flex' : 'none',
                          flexWrap: 'wrap',
                          padding: '10px',
                          backgroundColor: 'white',
                          borderRadius: '5px',
                        }}>
                          {/* WEB DESIGN & DEVELOPMENT Column */}
                          <li style={{ width: '90%' }} >
                            <span style={{ color: '#222222d1', fontWeight: 'bold', fontSize: '14px', display: 'block', margin: '15px' }}>
                              WEB DESIGN & DEVELOP
                            </span>
                            <ul style={{ padding: 0, margin: 0 }}>
                              <li style={{ margin: '7px 0' }}><a href="/webdevlop" onClick={() => handleNavClick('/webdevlop')}>Website Design</a></li>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>Website marginRight</a></li>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>CRM Software Development</a></li>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>Software Development</a></li>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>Educational Web Portal Development</a></li>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>Restaurant Web Portal Development</a></li>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>Travel Portal Development</a></li>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>E-Commerce Website Development</a></li>
                            </ul>
                          </li>

                          {/* SOFTWARE Column */}
                          <li style={{ width: '100%' }}>
                            <span style={{ color: '#222222d1', fontWeight: 'bold', fontSize: '14px', display: 'block', margin: '15px' }}>
                              SOFTWARE
                            </span>
                            <ul style={{ padding: 0, margin: 0 }}>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>HR and Payroll Management Software</a></li>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>CRM Software</a></li>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>Inventory Management Software</a></li>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>School Management Software</a></li>
                            </ul>
                          </li>

                          {/* MOBILE APPLICATION Column */}
                          <li style={{ width: '100%' }}>
                            <span style={{ color: '#222222d1', fontWeight: 'bold', fontSize: '14px', display: 'block', margin: '15px' }}>
                              MOBILE APPLICATION
                            </span>
                            <ul style={{ padding: 0, marginRight: -250 }}>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>Mobile App Development</a></li>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>Native App Development</a></li>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>Cross Platform Development</a></li>
                            </ul>
                          </li>

                          {/* LATEST THINKING Column */}
                          <li style={{ width: '100%' }}>
                            <span style={{ color: '#222222d1', fontWeight: 'bold', fontSize: '14px', display: 'block', margin: '15px' }}>
                              LATEST THINKING
                            </span>
                            <ul style={{ padding: 0, marginRight: -250 }}>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>Data Science</a></li>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>AI & ML</a></li>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>Data Analytics</a></li>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>Cloud Computing</a></li>
                              <li style={{ margin: '7px 0' }}><a href="#" onClick={() => handleNavClick('/')}>Digital Marketing</a></li>
                            </ul>
                          </li>
                        </ul>
                      </li>



                      <li className={`menu-item-has-children ${hasActiveChild(['/Web-develop', '/web-design', '/software-testing', '/ui-ux', '/cross-platform', '/mobile-app', '/crm-soft', '/web-design']) ? 'current-menu-item' : ''}`}>
                        <a href="#">Services</a>
                        <ul style={{ right: '-180px' }}>
                          <li className={isActive('/web-design') ? 'current-menu-item' : ''}>
                            <a href="/web-design" onClick={() => setActiveItem('/web-design')}>Web Design</a>
                          </li>
                          <li className={isActive('/Web-develop') ? 'current-menu-item' : ''}>
                            <a href="/Web-develop" onClick={() => setActiveItem('/Web-develop')}>Web Development</a>
                          </li>
                          <li className={isActive('/crm-soft') ? 'current-menu-item' : ''}>
                            <a href="/crm-soft" onClick={() => setActiveItem('/crm-soft')}>CRM Software</a>
                          </li>
                          <li className={isActive('/mobile-app') ? 'current-menu-item' : ''}>
                            <a href="/mobile-app" onClick={() => setActiveItem('/mobile-app')}>Mobile App Development</a>
                          </li>
                          <li className={isActive('/native-app') ? 'current-menu-item' : ''}>
                            <a href="/native-app" onClick={() => setActiveItem('/native-app')}>Native App Development</a>
                          </li>
                          <li className={isActive('/cross-platform') ? 'current-menu-item' : ''}>
                            <a href="/cross-platform" onClick={() => setActiveItem('/cross-platform')}>Cross Platform development</a>
                          </li>
                          <li className={isActive('/ui-ux') ? 'current-menu-item' : ''}>
                            <a href="/ui-ux" onClick={() => setActiveItem('/ui-ux')}>UI & UX</a>
                          </li>
                          <li className={isActive('/software-testing') ? 'current-menu-item' : ''}>
                            <a href="/software-testing" onClick={() => setActiveItem('/software-testing')}>Software Testing</a>
                          </li>
                          <li className={isActive('/secrity-testing') ? 'current-menu-item' : ''}>
                            <a href="/secrity-testing" onClick={() => setActiveItem('/secrity-testing')}>Security Testing</a>
                          </li>

                        </ul>
                      </li>
                      <li className={`menu-item-has-children ${hasActiveChild(['/Robotic', '/iot', '/digital', '/cloud', '/data-analytics', '/aiml', '/blockchain', '/data-science']) ? 'current-menu-item' : ''}`}>
                        <a href="#">Latest</a>
                        <ul style={{ right: '-180px' }}>
                          <li className={isActive('/Robotic') ? 'current-menu-item' : ''}>
                            <a href="/Robotic" onClick={() => setActiveItem('/Robotic')}>Robotic process automation</a>
                          </li>
                          <li className={isActive('/data-science') ? 'current-menu-item' : ''}>
                            <a href="/data-science" onClick={() => setActiveItem('/data-science')}>Data Science</a>
                          </li>
                          <li className={isActive('/blockchain') ? 'current-menu-item' : ''}>
                            <a href="/blockchain" onClick={() => setActiveItem('/blockchain')}>Blockchain</a>
                          </li>
                          <li className={isActive('/aiml') ? 'current-menu-item' : ''}>
                            <a href="/aiml" onClick={() => setActiveItem('/aiml')}>AI & ML</a>
                          </li>
                          <li className={isActive('/data-analytics') ? 'current-menu-item' : ''}>
                            <a href="/data-analytics" onClick={() => setActiveItem('/data-analytics')}>Data Analytics</a>
                          </li>
                          <li className={isActive('/iot') ? 'current-menu-item' : ''}>
                            <a href="/iot" onClick={() => setActiveItem('/iot')}>Internet of Things</a>
                          </li>
                          <li className={isActive('/cloud') ? 'current-menu-item' : ''}>
                            <a href="/cloud" onClick={() => setActiveItem('/cloud')}>Cloud Computing</a>
                          </li>
                          <li className={isActive('/digital') ? 'current-menu-item' : ''}>
                            <a href="/digital" onClick={() => setActiveItem('/digital')}>Digital Marketing</a>
                          </li>
                        </ul>
                      </li>

                      {/* <li className="menu-item-has-children">
                      <a href="/Portfolio">Portfolio</a>
                    </li> */}
                      <li className={isActive('/Portfolio') ? 'current-menu-item' : ''}>
                        <a href="/Portfolio" onClick={() => setActiveItem('/Portfolio')}>Portfolio</a>
                      </li>
                      {/* <li className="menu-item-has-children">
                      <a href="#">Clients</a>
                    </li>
                    
                     <li className={`menu-item-has-children ${hasActiveChild(['/blog-archive', '/blog-single']) ? 'current-menu-item' : ''}`}>
                      <a href="#">Blog</a>
                      <ul style={{ right: '-180px' }}>
                        <li className={isActive('/blog-archive') ? 'current-menu-item' : ''}>
                          <a href="/blog-archive" onClick={() => setActiveItem('/blog-archive')}>Blog List</a>
                        </li>
                        <li className={isActive('/blog-single') ? 'current-menu-item' : ''}>
                          <a href="/blog-single" onClick={() => setActiveItem('/blog-single')}>Blog Single</a>
                        </li>
                      </ul>
                    </li> */}

                      {/* <li className={isActive('/contact') ? 'current-menu-item' : ''}>
                        <a href="/contact" onClick={() => setActiveItem('/contact')}>Contact</a>
                      </li> */}
                    </ul>
                  </nav>





                  <div className="header-btn d-inline-block">
                    <a href="/contact" className="button-round">Contact Us</a>
                  </div>
                </div>

                {/* Mobile Toggle (only show on mobile) */}
                <div className="slicknav_menu d-lg-none mx-2 mb-2 d-flex justify-content-center align-items-center">
                  <button
                    onClick={toggleMobileMenu}
                    aria-haspopup="true"
                    role="button"
                    tabIndex={0}
                    className={`slicknav_btn ${isMobileMenuOpen ? 'slicknav_open' : 'slicknav_collapsed'}`}
                  >
                    <span className="slicknav_icon d-flex flex-column mx-2">
                      <span className="slicknav_icon-bar bg-black mb-1"></span>
                      <span className="slicknav_icon-bar bg-black mb-1"></span>
                      <span className="slicknav_icon-bar bg-black"></span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Mobile Menu */}
        <div className="mobile-menu-container d-lg-none" style={{ fontFamily: "" }}>
          <div className="slicknav_menu">
            {/* <button
              onClick={toggleMobileMenu}
              aria-haspopup="true"
              role="button"
              tabIndex={0}
              className={`slicknav_btn   ${isMobileMenuOpen ? 'slicknav_open' : 'slicknav_collapsed'}`}
            >
              <span className="slicknav_menutxt">Menu</span>
              <span className="slicknav_icon">
                <span className="slicknav_icon-bar"></span>
                <span className="slicknav_icon-bar"></span>
                <span className="slicknav_icon-bar"></span>
              </span>
            </button> */}
            <nav
              className={`slicknav_nav ${isMobileMenuOpen ? '' : 'slicknav_hidden d-none'}`}
              aria-hidden={!isMobileMenuOpen}
              role="menu"
            >
              <ul>
                <li className={isActive('/') ? 'current-menu-item' : ''}>
                  <a href="/" role="menuitem" onClick={() => { setIsMobileMenuOpen(false); setActiveItem('/'); }}>Home</a>
                </li>
                <li className={isActive('/about') ? 'current-menu-item' : ''}>
                  <a href="/about" role="menuitem" onClick={() => { setIsMobileMenuOpen(false); setActiveItem('/about'); }}>
                    About Us
                  </a>
                </li>
                <li className="menu-item-has-children slicknav_parent slicknav_collapsed">
                  <span className="slicknav_parent-link slicknav_row">
                    <a href="#" ClassName="slicknav_item" onClick={toggleSubmenu}>Services</a>
                    <a
                      href="#"
                      role="menuitem"
                      aria-haspopup="true"
                      tabIndex={-1}
                      className="slicknav_item"
                      onClick={toggleSubmenu}
                    >
                      <span className="slicknav_arrow">
                        <i className="fas fa-plus" />
                      </span>
                    </a>
                  </span>
                  <ul
                    role="menu"
                    className="slicknav_hidden"
                    aria-hidden="true"
                    style={{ display: 'none' }}
                  >
                    <li><a href="/web-design" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>Web Design</a></li>
                    <li><a href="/Web-develop" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>Web Development</a></li>
                    <li><a href="/crm-soft" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>CRM Software</a></li>
                    <li><a href="/mobile-app" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>Mobile App </a></li>
                    <li><a href="/native-app" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>Native App</a></li>
                    <li><a href="/cross-platform" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>Cross-Platform</a></li>
                    <li><a href="/ui-ux" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>UI/UX</a></li>
                    <li><a href="/software-testing" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>Software Testing</a></li>
                    <li><a href="/secrity-testing" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>Security Testing</a></li>

                  </ul>
                </li>
                <li className="menu-item-has-children slicknav_parent slicknav_collapsed">
                  <span className="slicknav_parent-link slicknav_row">
                    <a href="#" ClassName="slicknav_item" onClick={toggleSubmenu}>Latest</a>
                    <a
                      href="#"
                      role="menuitem"
                      aria-haspopup="true"
                      tabIndex={-1}
                      className="slicknav_item"
                      onClick={toggleSubmenu}
                    >
                      <span className="slicknav_arrow">
                        <i className="fas fa-plus" />
                      </span>
                    </a>
                  </span>
                  <ul
                    role="menu"
                    className="slicknav_hidden"
                    aria-hidden="true"
                    style={{ display: 'none' }}
                  >
                    <li><a href="/Robotic" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>Robotic</a></li>
                    <li><a href="/data-science" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>Data Science</a></li>
                    <li><a href="/blockchain" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>Blockchain</a></li>
                    <li><a href="/aiml" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>AI & ML </a></li>
                    <li><a href="/data-analytics" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>Data Analytics</a></li>
                    <li><a href="/iot" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>IoT Development </a></li>
                    <li><a href="/cloud" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>Cloud Computing</a></li>
                    <li><a href="/digital" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>Digital Marketing</a></li>
                  </ul>
                </li>
                <li className={isActive('/Portfolio') ? 'current-menu-item' : ''}>
                  <a href="/Portfolio" role="menuitem" onClick={() => { setIsMobileMenuOpen(false); setActiveItem('/Portfolio'); }}>
                    Portfolio
                  </a>
                </li>
                {/* <li className="menu-item-has-children slicknav_parent slicknav_collapsed">
                  <span className="slicknav_parent-link slicknav_row">
                    <a href="#">Blog</a>
                    <a
                      href="#"
                      role="menuitem"
                      aria-haspopup="true"
                      tabIndex={-1}
                      className="slicknav_item"
                      onClick={toggleSubmenu}
                    >
                      <span className="slicknav_arrow">
                        <i className="fas fa-plus" />
                      </span>
                    </a>
                  </span>
                  <ul
                    role="menu"
                    className="slicknav_hidden"
                    aria-hidden="true"
                    style={{ display: 'none' }}
                  >
                    <li><a href="/blog-archive" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>Blog List</a></li>
                    <li><a href="/blog-single" role="menuitem" tabIndex={-1} onClick={() => setIsMobileMenuOpen(false)}>Blog Single</a></li>
                  </ul>
                </li> */}
                <li className={isActive('/contact') ? 'current-menu-item' : ''}>
                  <a href="/contact" role="menuitem" style={{ fontSize: '12px' }} onClick={() => { setIsMobileMenuOpen(false); setActiveItem('/contact'); }}>
                    Contact
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>
    </div>
  );
}

export default Navbar;
